// eslint-disable-next-line no-shadow
export enum DocumentFileType {
  PDF = 'PDF',
  JPEG = 'JPEG',
  PNG = 'PNG',
  EML = 'EML',
  DOCX = 'DOCX',
  XLSX = 'XLSX',
}

export type Document = {
  name: string,
  size: number,
  type: string,
  extension: string,
  data: string,
}

export const EXTENSION_MIMETYPE: Record<string, string> = {
  [DocumentFileType.PDF]: 'application/pdf',
  [DocumentFileType.JPEG]: 'image/jpeg',
  [DocumentFileType.PNG]: 'image/png',
  [DocumentFileType.EML]: 'message/rfc822',
  [DocumentFileType.DOCX]: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  [DocumentFileType.XLSX]: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

export const convertFileToBase64 = (file: File): Promise<string> => new Promise((resolve) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    const base64String = (reader.result as string).split(',')[1];
    resolve(base64String);
  };
});

export const filesToDocuments = async (files: File[]): Promise<Document[]> => Promise.all(
  Array.from(files).map(async (file) => {
    const { name, size, type } = file;
    const data = await convertFileToBase64(file);
    const extension = name.split('.').pop() ?? '';

    return {
      name, size, type, extension, data,
    };
  }),
);
